export const ACTION_VALIDATION_ERROR_ADDED = "ACTION_VALIDATION_ERROR_ADDED";
export const ACTION_VALIDATION_ERROR_REMOVED = "ACTION_VALIDATION_ERROR_REMOVED";
export const ACTION_VALIDATION_CLEANED = "ACTION_VALIDATION_CLEANED";

export function ValidationReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_VALIDATION_ERROR_ADDED:
            return { ...state, ...action.payload }
        case ACTION_VALIDATION_ERROR_REMOVED:
            return { ...state, ...action.payload }
        case ACTION_VALIDATION_CLEANED:
            return {};
        default:
            return state;
    }
}